import React from "react"
import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../render/table/table-cell";
import {isBulkSelection} from "../../../../../gd/right-click-menu";
import FieldProto_updateView from "../../../../proto/render/table/function/update-view";

// const debug = "FieldProgress_TableCell"
const debug = false


export default class FieldProgress_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered       : false,
            showPopover     : false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) return false
        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {

        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    async onValueChange(value: Moment|null, hidePopover:boolean=true) {

        if (!this.props.field.fieldParams.tableCellOnValueChange) {
            console.error("#9dkjdsfdhd Not implemented ")
            return
        }

        await this.props.field.fieldParams.tableCellOnValueChange(this.props.listItem, value, this.props.manager)

        hidePopover && this.hidePopover()
        FieldProto_updateView(this.props.manager, this.props.field)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    onDeleteClick = async (e:React.MouseEvent)=>{
        if (isBulkSelection(e)) return
        e.stopPropagation()

        if (!this.props.field.fieldParams.tableCellOnValueChange) {
            console.error("#ggh9ddhd Not implemented ")
            return
        }
        await this.props.field.fieldParams.tableCellOnValueChange(this.props.listItem, null, this.props.manager)

        FieldProto_updateView(this.props.manager, this.props.field)
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderHovered() {

        const field     = this.props.field
        const classes   = Classes("cell-flex", "is-hovered")

        const value     = _.get(this.props.listItem.item, this.props.field.fieldId, 0)

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                    <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent" onClick={this.onClick}>

                        {!!value && this.renderValue()}
                        { !value && (
                            <div className="ui5-txt-less-important-small w-100-percent flex-row-left-center txt-truncate">
                                {this.props.field.label}
                            </div>
                        )}

                        <div className="buttons flex-no-shrink">
                            {!!value && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                            <div className="btn-arrow"/>
                        </div>

                    </div>

                    {this.state.showPopover &&
                        <field.components.PopoverMenu {...this.props} parent={this}/>
                    }
                </div>
            </React.Fragment>
        )
    }

    renderValue() {
        const style = getTableCellStyle(this.props)

        const value = _.get(this.props.listItem.item, this.props.field.fieldId, 0)
        const excess = value > 100;
        const currentValue = excess ? Math.floor(100 * (100 / value)) : value;
        const progressClasses = Classes("ui5-progress", "in-ui5-field", {
            'excess-v2':    excess,
        });

        if (_.isNil(value)) return false;

        const classes   = Classes("ui5-txt-less-important-small w-100-percent flex-row-left-center txt-truncate")

        const displayProgressBar = !!style.width && (style.width as number) > 70

        if (!displayProgressBar) {
            return (
                <div className={classes}>
                    <div className={progressClasses}>
                        {!_.isNil(currentValue) &&
                            <div className="ui5-txt-less-important-small percentage txt-truncate">
                                {"{0}%".f(currentValue)}
                            </div>
                        }
                    </div>
                </div>
            );
        }


        return (
            <div className={classes}>
                <div className={progressClasses}>
                    <div className="progress-bg">
                        {!!currentValue && <div className="progress-line" style={{width: '{0}%'.f(currentValue)}}/>}
                    </div>
                    {!_.isNil(currentValue) &&
                        <div className="m-l-10 ui5-txt-less-important-small">
                            {"{0}%".f(currentValue)}
                        </div>
                    }
                </div>
            </div>
        );
    }

    renderNotHovered() {
        const classes = Classes("cell-flex ui5-field-editable size-small")

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    {this.renderValue()}
                </div>
            </React.Fragment>
        )
    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()
    }
}



